import React, { useContext } from 'react'
import { useRouter } from 'next/router'
import { Elements } from '@stripe/react-stripe-js'
import { StepHeading, ContentContainer } from 'components/GetStarted/styles'
import StripePaymentForm from 'components/generic/StripePaymentForm'
import { trackClickEvent } from 'utils/Analytics'
import useStripePlan from 'hooks/useStripePlan'
import ContentLoadingIndicator from 'components/generic/ContentLoadingIndicator'
import { getCardholderName, getStripePromise } from 'utils/stripeUtils'
import { stripeFontStyles } from 'components/generic/Input/styles'
import { AppContext } from 'contexts/AppContext'
import PaymentSummary from 'components/PaymentSummary/PaymentSummary'

const stripePromise = getStripePromise()

const StepPayment = ({ data, userInput, onStepComplete }) => {
  const { domain } = useContext(AppContext)
  const { query } = useRouter()
  const { data: stripePlan = {}, loading } = useStripePlan({
    userInput,
    query,
  })
  const isStripePlanLoading = loading || Object.keys(stripePlan || {}).length === 0
  const submissionError = query?.error as string
  const relativePaymentReturnUrl = data?.viewer?.site?.payment_return_path
  const cardholderName = getCardholderName({ userInput, query })
  const onPurchaseComplete = (redirectUrl) => {
    trackClickEvent(domain, 'get-started-next-payment')
    redirectUrl ? (window.location.href = redirectUrl) : onStepComplete({ isSubscribed: true })
  }

  return (
    <ContentContainer>
      <StepHeading>Purchase Plan</StepHeading>
      <ContentLoadingIndicator isLoading={isStripePlanLoading}>
        <PaymentSummary stripePlan={stripePlan} />
        <Elements
          stripe={stripePromise}
          options={{
            fonts: stripeFontStyles,
          }}
        >
          <StripePaymentForm
            conversionType='get-started'
            flow='get-started'
            countryCode={data?.viewer?.countryCode}
            currency={data?.viewer?.currency}
            cardholderName={cardholderName}
            stripePlan={stripePlan}
            relativePaymentReturnUrl={relativePaymentReturnUrl}
            onPurchaseComplete={onPurchaseComplete}
            submissionError={submissionError}
          />
        </Elements>
      </ContentLoadingIndicator>
    </ContentContainer>
  )
}

export default StepPayment
